import pathname, { menuType } from '../../../constants/pathname'

export const auditSchema = {
  alwaysOpenKeys: ['1', '2'],
  menu: menuType.auditSchema,
  sidebars: [
    {
      id: 'section1',
      type: 'nav',
      items: [
        {
          eventKey: '1-1',
          icon: {
            name: 'home',
          },
          link: pathname.audit.AuditDashboard,
          children: 'หน้าหลักตรวจสอบภายใน ',
        },
      ],
    },
    {
      id: 'section2',
      type: 'nav',
      items: [
        {
          eventKey: '2-1',
          icon: {
            name: 'chevron-circle-right',
          },
          link: pathname.audit.PrepareProjectReview,
          children: 'ค้นหาโครงการสำหรับตรวจสอบ',
        },
      ],
    },
    {
      id: 'section1',
      type: 'dropdown',
      titleItem: {
        eventKey: '1',
        placement: 'rightStart',
        title: 'จัดการรายการตรวจสอบภายใน',
        icon: 'file-text-o',
      },
      items: [
        {
          eventKey: '1-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.audit.AuditReportSummary,
          children: 'รายการตรวจสอบภายใน',
        },
        {
          eventKey: '1-2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.audit.ReportsAudit,
          children: 'แบบสรุปรายงานผลการตรวจสอบภายใน',
        },
        // {
        //   eventKey: '1-3',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.audit.FollowAuditIssues,
        //   children: 'นักวิชาการติดตามประเด็นตรวจพบ',
        // },
        // {
        //   eventKey: '1-4',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.audit.DirectorFollowAuditIssues,
        //   children: 'ผู้อำนวยการติดตามประเด็นตรวจพบ',
        // },
        // {
        //   eventKey: '1-5',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.audit.FundManagerAuditIssues,
        //   children: 'ผู้จัดการกองทุนติดตามประเด็นตรวจพบ',
        // },
      ],
    },
    {
      id: 'section3',
      type: 'nav',
      items: [
        {
          eventKey: '3-1',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.audit.ListReportIssues,
          children: 'รายงานสรุปประเด็นตรวจพบ ',
        },
      ],
    },
  ],
}
